"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const testBranches = [];
exports.testOrganization = {
    id: 'testOrgSalesforceId',
    name: 'string',
    creditHoldStatus: false,
    billingAddress: {
        id: 'string',
        firstName: 'TestFirstName',
        lastName: 'TestLastName',
        company: 'TestOrgName',
        addressLine1: '255 S King St',
        addressLine2: '',
        addressType: 'string',
        city: 'Seattle',
        county: 'string',
        state: 'Washington',
        zipCode: '98104',
        country: 'United States',
        bypassValidation: false,
        isPrimary: true,
    },
    shippingAddress: {
        id: 'string',
        firstName: 'TestFirstName',
        lastName: 'TestLastName',
        company: 'TestOrgName',
        addressLine1: '255 S King St',
        addressLine2: '',
        addressType: 'string',
        city: 'Seattle',
        county: 'string',
        state: 'Washington',
        zipCode: '98104',
        country: 'United States',
        bypassValidation: false,
        isPrimary: true,
    },
    hasAICPAUid: true,
    AICPAUid: 'testOrgAicpaId',
    isFirmBillingEnabled: false,
    parentId: '',
    ultimateParentOrgId: '',
    phone: '07123456789',
    type: 'Public Accounting',
    branches: testBranches,
    currentParentId: 'string',
    numCPA: 1,
    isPCAOBOrganization: true,
    PCAOBNumOfIssuers: '0',
    underReview: false,
    isAICPAaffiliated: false,
    email: '',
    tuitionProviderType: '',
    key: '',
    addressType: 'string',
    taxExemption: false,
    legalEntity: 'string',
    channels: '',
    department: '',
    companyFax: '',
    fcmaFrom: '',
    fcmaTo: '',
    membershipBodies: '',
    areaCode: 'string',
    extension: 'string',
    isCIMAFirmBillingEnabled: false,
    isFLPFirmBillingEnabled: false,
    aicpaFirmBillingType: '',
    cimaFirmBillingType: '',
    isFLPOnlyEnabled: true,
    organizationCapabilities: {
        type: types_1.Salesforce.LegalEntity.ASSOCIATION,
        isFLP: false,
    },
    currency: types_1.Product.ProductCurrencyLabel.USD,
    hasMOU: false,
    peerReviewEnrollmentStatus: 'string',
    accountId: 'string',
    accountNumber: 'testOrgSalesforceAccountNumber',
};
exports.testActiveMembershipTerm = {
    id: 'testMembershipTermSalesforceId',
    name: 'testMembershipTermSalesforceName',
    applicationPartId: 'testApplicationPartId',
    expiryDate: 'testActiveMembershipEndDate',
    isPaidByFirm: 'true',
    membershipId: 'testMembershipSalesforceId',
    orderLineItemId: 'testOrderSalesforceId',
    productId: 'MEMCAQ0122',
    startDate: 'testMembershipStartDate',
    zuoraOrderNumber: 'testZuoraOrderNumber',
    membershipAccessUrl: 'testLinkToSitMembershipProvisioning',
    organizationId: 'testOrgSalesforceId',
    adminEmail: 'testOrgAdminEmail',
    firmMembershipType: 'CAQ - Regular',
    membershipTermType: 'CAQ - Regular',
    membershipTermTier: 'Open  and 6+ 0 IA',
    membershipTermSku: 'MEMCAQ0122',
};
exports.testInactiveMembershipTerm = {
    id: 'testMembershipTermSalesforceId',
    name: 'testMembershipTermSalesforceName',
    applicationPartId: 'testApplicationPartId',
    expiryDate: 'testInactiveMembershipEndDate',
    isPaidByFirm: 'true',
    membershipId: 'testMembershipSalesforceId',
    orderLineItemId: 'testOrderSalesforceId',
    productId: 'MEMCAQ0122',
    startDate: 'testMembershipStartDate',
    zuoraOrderNumber: 'testZuoraOrderNumber',
    membershipAccessUrl: 'testLinkToSitMembershipProvisioning',
    organizationId: 'testOrgSalesforceId',
    adminEmail: 'testOrgAdminEmail',
    firmMembershipType: 'CAQ - Regular',
    membershipTermType: 'CAQ - Regular',
    membershipTermTier: 'Open  and 6+ 0 IA',
    membershipTermSku: 'MEMCAQ0122',
};
exports.testFirmMembership = {
    id: 'testMembershipSalesforceId',
    name: 'testMembershipSalesforceIdWithoutQA2',
    accountKey: 'testOrgSalesforceId',
    accessUrl: 'testLinkToSitMembershipProvisioning',
    adminAccountId: 'testOrgAdminSalesforceId',
    endDate: 'testActiveMembershipEndDate',
    firmMembershipType: 'CAQ - Regular',
    membershipBody: 'AICPA',
    memberSinceDate: '1970-01-01',
    since: '1970-01-01',
    status: 'Active',
    terminationComments: '',
    terminationReason: '',
    membershipTerm: exports.testActiveMembershipTerm,
    inactiveTerms: [exports.testInactiveMembershipTerm],
    allTerms: [exports.testActiveMembershipTerm, exports.testInactiveMembershipTerm],
    numberOfCpa: '1',
    admin: {
        name: 'testOrgAdminName',
        email: 'testOrgAdminEmail',
        parentId: 'testOrgParentId',
        ultimateParentOrgId: 'testOrgUltimateParentId',
    },
    slug: 'string',
};
//# sourceMappingURL=index.js.map